import { useState } from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import toast from "react-hot-toast";
// import { motion } from "framer-motion";

const Contact = () => {
  return (
    <>
      <ContactSection />
    </>
  );
};

export default Contact;

/* ---------------- Animations ---------------- */

const easeOut = [0.25, 0.1, 0.25, 1];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: easeOut },
  },
};

const stagger = {
  visible: {
    transition: { staggerChildren: 0.15 },
  },
};

/* ---------------- Section ---------------- */

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
      toast.error("Please fill in all fields.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("https://sastha.azerotech.com/api/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        toast.success(result.message || "Message sent successfully!");
        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        toast.error(result.message || "Failed to send message.");
      }
    } catch (error) {
      toast.error("An error occurred while sending the message.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-[#FFFEF2]  text-black p-5 md:p-20 relative overflow-hidden">
      <div className="mx-auto grid lg:grid-cols-[1fr_auto] gap-12">
        {/* Left Content */}
        <div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
        >
          <span
            variants={fadeUp}
            className="text-[20px] block mb-6 font-creto font-medium"
          >
            Get Started
          </span>

          <h1
            variants={fadeUp}
            className="text-4xl md:text-[75px] lg:text-6xl  max-w-3xl font-calson  font-medium leading-tight mb-16"
          >
            Get in touch with us. We're here to assist you.
          </h1>

          {/* Form */}
          <form variants={stagger} className="space-y-14" onSubmit={handleSubmit}>
            <div variants={fadeUp} className="grid md:grid-cols-3 gap-10">
              <Input
                label="Your Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              <Input
                label="Email Address"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
              <Input
                label="Phone Number"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div variants={fadeUp}>
              <Input
                label="Message"
                name="message"
                value={formData.message}
                onChange={handleChange}
              />
            </div>

            <div variants={fadeUp} className="flex justify-end">
              <button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                type="submit"
                disabled={loading}
                className="bg-primary hover:bg-primary/80 cursor-pointer transition text-white px-8 py-4 rounded-full flex items-center gap-2 text-sm forma-medium disabled:opacity-70"
              >
                {loading ? "Sending..." : "Leave us a Message"} <span>→</span>
              </button>
            </div>
          </form>
        </div>

        {/* Social Icons */}
        {/* <div className="flex md:absolute right-32 md:justify-start justify-center md:flex-col gap-4 md:mt-20"> */}
          {/* <SocialIcon
            icon={<FaFacebook size={24} />}
            link="https://www.facebook.com/SasthaGrand"
          />
          <SocialIcon
            icon={<FaInstagram size={24} />}
            link="https://www.instagram.com/sasthagrand/"
          /> */}
          {/* <SocialIcon icon={<FaXTwitter size={24} />} link="" /> */}
        {/* </div> */}
      </div>
    </section>
  );
};

/* ---------------- Components ---------------- */

const Input = ({ label, name, type = "text", value, onChange }) => (
  <div>
    <label className="block text-sm text-gray-500 mb-2  font-creto font-medium">
      {label}
    </label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      className="w-full border-b border-gray-300 focus:border-black outline-none py-2 text-sm transition bg-transparent font-creto font-normal"
    />
  </div>
);

const SocialIcon = ({ icon, link }) => (
  <a
    href={link}
    whileHover={{ scale: 1.15 }}
    whileTap={{ scale: 0.9 }}
    target="_blank"
    className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center cursor-pointer hover:bg-primary hover:text-white transition"
  >
    {icon}
  </a>
);
